import { render } from "./index.vue?vue&type=template&id=706cf80a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=706cf80a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706cf80a"],['__file',"src/components/StepOpt/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "706cf80a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('706cf80a', __exports__)) {
    api.reload('706cf80a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=706cf80a&scoped=true", () => {
    api.rerender('706cf80a', render)
  })

}


export default __exports__